/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CursorPaginatedResponseSuppliersRequestListV1Dto } from '../models/cursor-paginated-response-suppliers-request-list-v-1-dto';
import { CursorPaginationRequest } from '../models/cursor-pagination-request';
import { RequestApproveCommandV1 } from '../models/request-approve-command-v-1';
import { RequestBulkCancelCommandV1 } from '../models/request-bulk-cancel-command-v-1';
import { RequestBulkCancelResponseV1 } from '../models/request-bulk-cancel-response-v-1';
import { RequestCancelCommandV1 } from '../models/request-cancel-command-v-1';
import { RequestCancellationReasonV1 } from '../models/request-cancellation-reason-v-1';
import { RequestErpSyncStatusCommandV1 } from '../models/request-erp-sync-status-command-v-1';
import { RequestRejectCommandV1 } from '../models/request-reject-command-v-1';
import { RequestRejectionReasonDtov1 } from '../models/request-rejection-reason-dtov-1';
import { SupplierCreateCommandV1 } from '../models/supplier-create-command-v-1';
import { SupplierRequestCreateCommandDtov1 } from '../models/supplier-request-create-command-dtov-1';
import { SupplierRequestDetailV1 } from '../models/supplier-request-detail-v-1';
import { SupplierRequestExternalCommandV1 } from '../models/supplier-request-external-command-v-1';
import { SupplierRequestInternalCommandV1 } from '../models/supplier-request-internal-command-v-1';
import { SupplierRequestQueryV1 } from '../models/supplier-request-query-v-1';


/**
 * API for supplier requests.
 */
@Injectable({
  providedIn: 'root',
})
export class SupplierRequestV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createSupplierRequest
   */
  static readonly CreateSupplierRequestPath = '/v1/supplier-requests';

  /**
   * Create new supplier request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSupplierRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSupplierRequest$Response(params: {

    /**
     * Supplier request to be created
     */
    body: SupplierCreateCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierRequestQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.CreateSupplierRequestPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierRequestQueryV1>;
      })
    );
  }

  /**
   * Create new supplier request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSupplierRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSupplierRequest(params: {

    /**
     * Supplier request to be created
     */
    body: SupplierCreateCommandV1
  },
  context?: HttpContext

): Observable<SupplierRequestQueryV1> {

    return this.createSupplierRequest$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierRequestQueryV1>) => r.body as SupplierRequestQueryV1)
    );
  }

  /**
   * Path part for operation createRequestsForExistingSupplier
   */
  static readonly CreateRequestsForExistingSupplierPath = '/v1/supplier-requests';

  /**
   * Create requests for existing supplier.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRequestsForExistingSupplier()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRequestsForExistingSupplier$Response(params: {

    /**
     * Payload for creating a new requests for supplier
     */
    body: SupplierRequestCreateCommandDtov1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierRequestQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.CreateRequestsForExistingSupplierPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierRequestQueryV1>;
      })
    );
  }

  /**
   * Create requests for existing supplier.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRequestsForExistingSupplier$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRequestsForExistingSupplier(params: {

    /**
     * Payload for creating a new requests for supplier
     */
    body: SupplierRequestCreateCommandDtov1
  },
  context?: HttpContext

): Observable<SupplierRequestQueryV1> {

    return this.createRequestsForExistingSupplier$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierRequestQueryV1>) => r.body as SupplierRequestQueryV1)
    );
  }

  /**
   * Path part for operation listSupplierRequestsV1Cursor
   */
  static readonly ListSupplierRequestsV1CursorPath = '/v1/supplier-requests/cursor-list';

  /**
   * List supplier requests using cursor-based pagination.
   *
   * Retrieves supplier requests using continuation token pagination. Supports filtering and sorting. Maximum page size is 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSupplierRequestsV1Cursor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listSupplierRequestsV1Cursor$Response(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CursorPaginatedResponseSuppliersRequestListV1Dto>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.ListSupplierRequestsV1CursorPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CursorPaginatedResponseSuppliersRequestListV1Dto>;
      })
    );
  }

  /**
   * List supplier requests using cursor-based pagination.
   *
   * Retrieves supplier requests using continuation token pagination. Supports filtering and sorting. Maximum page size is 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSupplierRequestsV1Cursor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listSupplierRequestsV1Cursor(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<CursorPaginatedResponseSuppliersRequestListV1Dto> {

    return this.listSupplierRequestsV1Cursor$Response(params,context).pipe(
      map((r: StrictHttpResponse<CursorPaginatedResponseSuppliersRequestListV1Dto>) => r.body as CursorPaginatedResponseSuppliersRequestListV1Dto)
    );
  }

  /**
   * Path part for operation listSuppliersRequestsV1CursorLegacy
   */
  static readonly ListSuppliersRequestsV1CursorLegacyPath = '/v1/supplier-requests/cursor-list/{supplierId}';

  /**
   * Deprecated: use /cursor-list/supplier instead.
   *
   * Deprecated: use /cursor-list/supplier instead. The supplierId path segment is ignored — retrieves requests for the caller's own supplier, derived from the authenticated user. Kept temporarily for backwards compatibility with frontend instances deployed before this endpoint moved.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSuppliersRequestsV1CursorLegacy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  listSuppliersRequestsV1CursorLegacy$Response(params: {
    supplierId: string;

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CursorPaginatedResponseSuppliersRequestListV1Dto>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.ListSuppliersRequestsV1CursorLegacyPath, 'post');
    if (params) {
      rb.path('supplierId', params.supplierId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CursorPaginatedResponseSuppliersRequestListV1Dto>;
      })
    );
  }

  /**
   * Deprecated: use /cursor-list/supplier instead.
   *
   * Deprecated: use /cursor-list/supplier instead. The supplierId path segment is ignored — retrieves requests for the caller's own supplier, derived from the authenticated user. Kept temporarily for backwards compatibility with frontend instances deployed before this endpoint moved.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSuppliersRequestsV1CursorLegacy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  listSuppliersRequestsV1CursorLegacy(params: {
    supplierId: string;

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<CursorPaginatedResponseSuppliersRequestListV1Dto> {

    return this.listSuppliersRequestsV1CursorLegacy$Response(params,context).pipe(
      map((r: StrictHttpResponse<CursorPaginatedResponseSuppliersRequestListV1Dto>) => r.body as CursorPaginatedResponseSuppliersRequestListV1Dto)
    );
  }

  /**
   * Path part for operation listSuppliersRequestsV1Cursor
   */
  static readonly ListSuppliersRequestsV1CursorPath = '/v1/supplier-requests/cursor-list/supplier';

  /**
   * List the caller's own supplier requests using cursor-based pagination.
   *
   * Retrieves requests for the caller's own supplier (derived from the authenticated user, not a request parameter) using continuation token pagination. Supports filtering and sorting. Maximum page size is 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSuppliersRequestsV1Cursor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listSuppliersRequestsV1Cursor$Response(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CursorPaginatedResponseSuppliersRequestListV1Dto>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.ListSuppliersRequestsV1CursorPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CursorPaginatedResponseSuppliersRequestListV1Dto>;
      })
    );
  }

  /**
   * List the caller's own supplier requests using cursor-based pagination.
   *
   * Retrieves requests for the caller's own supplier (derived from the authenticated user, not a request parameter) using continuation token pagination. Supports filtering and sorting. Maximum page size is 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSuppliersRequestsV1Cursor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listSuppliersRequestsV1Cursor(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<CursorPaginatedResponseSuppliersRequestListV1Dto> {

    return this.listSuppliersRequestsV1Cursor$Response(params,context).pipe(
      map((r: StrictHttpResponse<CursorPaginatedResponseSuppliersRequestListV1Dto>) => r.body as CursorPaginatedResponseSuppliersRequestListV1Dto)
    );
  }

  /**
   * Path part for operation rejectSupplierRequest
   */
  static readonly RejectSupplierRequestPath = '/v1/supplier-requests/{requestId}/rejection';

  /**
   * Reject a supplier request.
   *
   * Rejects a supplier request at the specified stage with a mandatory reason
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rejectSupplierRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rejectSupplierRequest$Response(params: {
    requestId: string;

    /**
     * Rejection details with mandatory reason
     */
    body: RequestRejectCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierRequestQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.RejectSupplierRequestPath, 'patch');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierRequestQueryV1>;
      })
    );
  }

  /**
   * Reject a supplier request.
   *
   * Rejects a supplier request at the specified stage with a mandatory reason
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rejectSupplierRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rejectSupplierRequest(params: {
    requestId: string;

    /**
     * Rejection details with mandatory reason
     */
    body: RequestRejectCommandV1
  },
  context?: HttpContext

): Observable<SupplierRequestQueryV1> {

    return this.rejectSupplierRequest$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierRequestQueryV1>) => r.body as SupplierRequestQueryV1)
    );
  }

  /**
   * Path part for operation saveInternalData
   */
  static readonly SaveInternalDataPath = '/v1/supplier-requests/{requestId}/internal';

  /**
   * Update internal data for a supplier request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveInternalData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveInternalData$Response(params: {
    requestId: string;

    /**
     * Supplier request internal data update
     */
    body: SupplierRequestInternalCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.SaveInternalDataPath, 'patch');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update internal data for a supplier request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `saveInternalData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveInternalData(params: {
    requestId: string;

    /**
     * Supplier request internal data update
     */
    body: SupplierRequestInternalCommandV1
  },
  context?: HttpContext

): Observable<void> {

    return this.saveInternalData$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation submitInternalRequestData
   */
  static readonly SubmitInternalRequestDataPath = '/v1/supplier-requests/{requestId}/internal/submit';

  /**
   * Submit internal request data for existing request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitInternalRequestData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitInternalRequestData$Response(params: {
    requestId: string;

    /**
     * Supplier request content
     */
    body: SupplierRequestInternalCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.SubmitInternalRequestDataPath, 'patch');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Submit internal request data for existing request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `submitInternalRequestData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitInternalRequestData(params: {
    requestId: string;

    /**
     * Supplier request content
     */
    body: SupplierRequestInternalCommandV1
  },
  context?: HttpContext

): Observable<void> {

    return this.submitInternalRequestData$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation saveExternalData
   */
  static readonly SaveExternalDataPath = '/v1/supplier-requests/{requestId}/external';

  /**
   * Save external data for a supplier request.
   *
   * Allows supplier users to save progress on external sections of a request form. Data is validated before saving. Progress can be saved while required fields are empty.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveExternalData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveExternalData$Response(params: {
    requestId: string;

    /**
     * Supplier request external data to save
     */
    body: SupplierRequestExternalCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.SaveExternalDataPath, 'patch');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Save external data for a supplier request.
   *
   * Allows supplier users to save progress on external sections of a request form. Data is validated before saving. Progress can be saved while required fields are empty.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `saveExternalData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveExternalData(params: {
    requestId: string;

    /**
     * Supplier request external data to save
     */
    body: SupplierRequestExternalCommandV1
  },
  context?: HttpContext

): Observable<void> {

    return this.saveExternalData$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation submitExternalRequestData
   */
  static readonly SubmitExternalRequestDataPath = '/v1/supplier-requests/{requestId}/external/submit';

  /**
   * Submit external data for a supplier request.
   *
   * Submits the external data and transitions the request to the next workflow stage. This endpoint validates external data and moves the request to REQUIRES_REVIEW_EXTERNAL status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitExternalRequestData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitExternalRequestData$Response(params: {
    requestId: string;

    /**
     * Supplier request external data to submit
     */
    body: SupplierRequestExternalCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.SubmitExternalRequestDataPath, 'patch');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Submit external data for a supplier request.
   *
   * Submits the external data and transitions the request to the next workflow stage. This endpoint validates external data and moves the request to REQUIRES_REVIEW_EXTERNAL status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `submitExternalRequestData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitExternalRequestData(params: {
    requestId: string;

    /**
     * Supplier request external data to submit
     */
    body: SupplierRequestExternalCommandV1
  },
  context?: HttpContext

): Observable<void> {

    return this.submitExternalRequestData$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation updateRequestErpSyncStatus
   */
  static readonly UpdateRequestErpSyncStatusPath = '/v1/supplier-requests/{requestId}/erp-sync-status';

  /**
   * Update the ERP sync status and/or reference of a supplier request.
   *
   * Updates the ERP sync status of a request, optionally together with the request ERP reference. From Approved, the status can be set to ERP synced or ERP sync failed. From ERP sync failed, it can only be set to ERP synced. ERP synced is terminal. Resending the current status is allowed and is treated as a reference-only update. Restricted to admins and approvers who were assigned to the request.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRequestErpSyncStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRequestErpSyncStatus$Response(params: {
    requestId: string;

    /**
     * Target ERP sync status and optional request ERP reference
     */
    body: RequestErpSyncStatusCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierRequestQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.UpdateRequestErpSyncStatusPath, 'patch');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierRequestQueryV1>;
      })
    );
  }

  /**
   * Update the ERP sync status and/or reference of a supplier request.
   *
   * Updates the ERP sync status of a request, optionally together with the request ERP reference. From Approved, the status can be set to ERP synced or ERP sync failed. From ERP sync failed, it can only be set to ERP synced. ERP synced is terminal. Resending the current status is allowed and is treated as a reference-only update. Restricted to admins and approvers who were assigned to the request.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRequestErpSyncStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRequestErpSyncStatus(params: {
    requestId: string;

    /**
     * Target ERP sync status and optional request ERP reference
     */
    body: RequestErpSyncStatusCommandV1
  },
  context?: HttpContext

): Observable<SupplierRequestQueryV1> {

    return this.updateRequestErpSyncStatus$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierRequestQueryV1>) => r.body as SupplierRequestQueryV1)
    );
  }

  /**
   * Path part for operation cancelSupplierRequest
   */
  static readonly CancelSupplierRequestPath = '/v1/supplier-requests/{requestId}/cancellation';

  /**
   * Cancel a supplier request.
   *
   * Cancels a supplier request with a mandatory reason
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelSupplierRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cancelSupplierRequest$Response(params: {
    requestId: string;

    /**
     * Cancellation details with mandatory reason
     */
    body: RequestCancelCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierRequestQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.CancelSupplierRequestPath, 'patch');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierRequestQueryV1>;
      })
    );
  }

  /**
   * Cancel a supplier request.
   *
   * Cancels a supplier request with a mandatory reason
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelSupplierRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cancelSupplierRequest(params: {
    requestId: string;

    /**
     * Cancellation details with mandatory reason
     */
    body: RequestCancelCommandV1
  },
  context?: HttpContext

): Observable<SupplierRequestQueryV1> {

    return this.cancelSupplierRequest$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierRequestQueryV1>) => r.body as SupplierRequestQueryV1)
    );
  }

  /**
   * Path part for operation approveSupplierRequest
   */
  static readonly ApproveSupplierRequestPath = '/v1/supplier-requests/{requestId}/approvals';

  /**
   * Approve a supplier request.
   *
   * Updates the approval status for a supplier request at the specified stage
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveSupplierRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approveSupplierRequest$Response(params: {
    requestId: string;

    /**
     * Approval details
     */
    body: RequestApproveCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierRequestQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.ApproveSupplierRequestPath, 'patch');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierRequestQueryV1>;
      })
    );
  }

  /**
   * Approve a supplier request.
   *
   * Updates the approval status for a supplier request at the specified stage
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `approveSupplierRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approveSupplierRequest(params: {
    requestId: string;

    /**
     * Approval details
     */
    body: RequestApproveCommandV1
  },
  context?: HttpContext

): Observable<SupplierRequestQueryV1> {

    return this.approveSupplierRequest$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierRequestQueryV1>) => r.body as SupplierRequestQueryV1)
    );
  }

  /**
   * Path part for operation bulkCancelSupplierRequests
   */
  static readonly BulkCancelSupplierRequestsPath = '/v1/supplier-requests/bulk/cancellation';

  /**
   * Cancel multiple supplier requests in bulk.
   *
   * Cancels multiple supplier requests with a shared reason. Returns per-request results.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkCancelSupplierRequests()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkCancelSupplierRequests$Response(params: {

    /**
     * Bulk cancellation details with request IDs and mandatory reason
     */
    body: RequestBulkCancelCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RequestBulkCancelResponseV1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.BulkCancelSupplierRequestsPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RequestBulkCancelResponseV1>;
      })
    );
  }

  /**
   * Cancel multiple supplier requests in bulk.
   *
   * Cancels multiple supplier requests with a shared reason. Returns per-request results.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkCancelSupplierRequests$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkCancelSupplierRequests(params: {

    /**
     * Bulk cancellation details with request IDs and mandatory reason
     */
    body: RequestBulkCancelCommandV1
  },
  context?: HttpContext

): Observable<RequestBulkCancelResponseV1> {

    return this.bulkCancelSupplierRequests$Response(params,context).pipe(
      map((r: StrictHttpResponse<RequestBulkCancelResponseV1>) => r.body as RequestBulkCancelResponseV1)
    );
  }

  /**
   * Path part for operation getSupplierRequestById
   */
  static readonly GetSupplierRequestByIdPath = '/v1/supplier-requests/{requestId}';

  /**
   * Get supplier request by ID.
   *
   * Returns full supplier request data including internal, external, and notes data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSupplierRequestById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSupplierRequestById$Response(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierRequestDetailV1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.GetSupplierRequestByIdPath, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierRequestDetailV1>;
      })
    );
  }

  /**
   * Get supplier request by ID.
   *
   * Returns full supplier request data including internal, external, and notes data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSupplierRequestById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSupplierRequestById(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<SupplierRequestDetailV1> {

    return this.getSupplierRequestById$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierRequestDetailV1>) => r.body as SupplierRequestDetailV1)
    );
  }

  /**
   * Path part for operation getRequestRejectionReasons
   */
  static readonly GetRequestRejectionReasonsPath = '/v1/supplier-requests/{requestId}/rejection-reasons';

  /**
   * Get rejection reasons for a request.
   *
   * Returns the historical list of rejection reasons for a supplier request
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRequestRejectionReasons()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRequestRejectionReasons$Response(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RequestRejectionReasonDtov1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.GetRequestRejectionReasonsPath, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RequestRejectionReasonDtov1>;
      })
    );
  }

  /**
   * Get rejection reasons for a request.
   *
   * Returns the historical list of rejection reasons for a supplier request
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRequestRejectionReasons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRequestRejectionReasons(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<RequestRejectionReasonDtov1> {

    return this.getRequestRejectionReasons$Response(params,context).pipe(
      map((r: StrictHttpResponse<RequestRejectionReasonDtov1>) => r.body as RequestRejectionReasonDtov1)
    );
  }

  /**
   * Path part for operation getSupplierRequestByIdOwn
   */
  static readonly GetSupplierRequestByIdOwnPath = '/v1/supplier-requests/{requestId}/own';

  /**
   * Get supplier request by ID (for supplier users).
   *
   * Returns supplier request data for supplier users. Internal data is encrypted to protect sensitive information in transit while still enabling cross-section form conditionality rules in SurveyJS.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSupplierRequestByIdOwn()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSupplierRequestByIdOwn$Response(params: {
    requestId: string;
    'X-Client-Public-Key'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierRequestDetailV1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.GetSupplierRequestByIdOwnPath, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.header('X-Client-Public-Key', params['X-Client-Public-Key'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierRequestDetailV1>;
      })
    );
  }

  /**
   * Get supplier request by ID (for supplier users).
   *
   * Returns supplier request data for supplier users. Internal data is encrypted to protect sensitive information in transit while still enabling cross-section form conditionality rules in SurveyJS.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSupplierRequestByIdOwn$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSupplierRequestByIdOwn(params: {
    requestId: string;
    'X-Client-Public-Key'?: string;
  },
  context?: HttpContext

): Observable<SupplierRequestDetailV1> {

    return this.getSupplierRequestByIdOwn$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierRequestDetailV1>) => r.body as SupplierRequestDetailV1)
    );
  }

  /**
   * Path part for operation getRequestCancellationReason
   */
  static readonly GetRequestCancellationReasonPath = '/v1/supplier-requests/{requestId}/cancellation-reason';

  /**
   * Get cancellation reason for a request.
   *
   * Returns the cancellation reason details for a cancelled supplier request
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRequestCancellationReason()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRequestCancellationReason$Response(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RequestCancellationReasonV1>> {

    const rb = new RequestBuilder(this.rootUrl, SupplierRequestV1Service.GetRequestCancellationReasonPath, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RequestCancellationReasonV1>;
      })
    );
  }

  /**
   * Get cancellation reason for a request.
   *
   * Returns the cancellation reason details for a cancelled supplier request
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRequestCancellationReason$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRequestCancellationReason(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<RequestCancellationReasonV1> {

    return this.getRequestCancellationReason$Response(params,context).pipe(
      map((r: StrictHttpResponse<RequestCancellationReasonV1>) => r.body as RequestCancellationReasonV1)
    );
  }

}
